import { useSidebar } from '@cortex/ui';
import { Menu } from 'lucide-react';

export function MobileHeader() {
  const { toggleSidebar } = useSidebar();
  return (
    <header className="relative flex items-center justify-center px-6 py-4 md:hidden bg-[var(--nav-from)]">
      <button
        type="button"
        onClick={toggleSidebar}
        aria-label="Toggle sidebar"
        className="absolute left-4 flex items-center justify-center size-8 rounded-lg bg-transparent border-0 cursor-pointer text-white hover:bg-white/10 transition-colors"
      >
        <Menu size={24} />
      </button>
      <h1 className="text-xl font-semibold text-white">TIVA CORTEX</h1>
    </header>
  );
}
